module.exports = new __parcel__URL__("deployment-tab-skeleton.tpl.6442d1f9.svg").toString();